import { RESILIENCE_ITEMS, RESILIENCE_DIMS } from "./questionBank.js";
import { scoreResilience, RS_NORMS, RS_BANDS, RS_DIM_THRESHOLDS, RS_ROLE_CRITICAL } from "./scoring.js";
export { RESILIENCE_DIMS, RS_NORMS, RS_BANDS, RS_DIM_THRESHOLDS, RS_ROLE_CRITICAL };

const ResilienceScreener = {
  id:"resilience", name:"Resilience Screener", shortName:"Resilience",
  icon:"💪", color:"#7c3aed", bg:"#f5f3ff",
  description:"25-item resilience screener adapted from the Connor-Davidson Resilience Scale (CD-RISC) and NEO-PI Emotional Stability facet. Measures Hardiness, Recovery Speed, Adaptability, Self-Efficacy and Emotional Control. Delivers Low / Moderate / High risk banding for high-pressure role hiring.",
  desc:"25 items · 8 minutes · Risk banding · Instant shortlist",
  publisher:"AXIS360 Express", version:"1.0",
  itemCount:25, items:25, timeLimit:8, time:"8 min", timeEstimate:"8 minutes",
  format:       "likert_0_4", scaleType:"likert-5", isScreener:true, isExpress:true, pricingTier:"volume", creditCost:20,
    pagesOf:25, totalPages:1, scaleMin:0, scaleMax:4,
  scale:{ min:0, max:4, labels:["Not at all true","Rarely true","Sometimes true","Often true","Nearly always true"] },
  scaleLabels:["Not at all true","Rarely true","Sometimes true","Often true","Nearly always true"],
  predicts:["Performance under sustained pressure","Sickness absence rates","Burnout risk","Handling adversarial customers or situations"],
  questions: RESILIENCE_ITEMS,
  dims: RESILIENCE_DIMS,
  score(answers){ return scoreResilience(answers); },
  nineboxAxes:{ x:{label:"Resilience",scaleIds:["resilience"]}, y:{label:"Resilience",scaleIds:["resilience"]} },
};
export default ResilienceScreener;
